import { apiFetch } from "./apiFetch";
import { getApiErrorMessage } from "./apiError";

const API_URL = process.env.REACT_APP_API_URL;

export interface NotificationDocument {
  documentId: string;
  documentNo: string;
}

export interface NotificationGroup {
  documentStatus: string;
  documentStatusText: string;
  documents: NotificationDocument[];
}

export async function getNotifications(
  companyId: string
): Promise<NotificationGroup[]> {
  const res = await apiFetch(
    `${API_URL}/notifications/${companyId}`
  );

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się pobrać powiadomień.")
    );
  }

  return res.json();
}

export async function clearNotificationGroup(
  companyId: string,
  status: string
): Promise<void> {
  const res = await apiFetch(
    `${API_URL}/notifications/${companyId}/${encodeURIComponent(status)}`,
    {
      method: "DELETE",
    }
  );

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się usunąć powiadomień.")
    );
  }
}
